import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { ICheckesDataResponse } from 'ApiPackage/OpenDataModule/interfaces/ICheckesDataResponse';
import { IOpenDataResponse } from 'ApiPackage/OpenDataModule/interfaces/IOpenDataResponse';
import { getOpenData, getCheckesData, getCheckesPlansData } from 'ApiPackage/OpenDataModule/services/openData';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { PublicOpenDataActionsEnum } from '../enums/PublicOpenDataActionsEnum';
import { getPublicOpenDataActiveTab } from '../reducers/publicOpenDataReducer';
import {
  publicOpenDataGetData,
  publicOpenDataSetData,
  publicOpenDataSetActiveTab,
  publicOpenDataGetChecksData,
  publicOpenDataSetChecksData,
} from '../actions/publicOpenDataActions';
import { IActiveTab } from '../interfaces/IActiveTab';

function* publicOpenDataGetDataSaga(action: ActionType<typeof publicOpenDataGetData>) {
  function* funcTry() {
    const { federalLaw } = action.payload;
    const activeTab: IActiveTab | undefined = yield select(getPublicOpenDataActiveTab);
    const data: IOpenDataResponse = yield getOpenData(federalLaw.value);
    if (data) {
      yield put(publicOpenDataSetData(data));
      const currentYear =
        (activeTab && data.years.find(item => Number(item) === Number(activeTab.year.value))) ||
        Math.max(...data.years);
      yield put(
        publicOpenDataSetActiveTab({
          year: { id: String(currentYear), label: String(currentYear), value: String(currentYear) },
          federalLaw,
        }),
      );
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* publicOpenDataGetChecksDataSaga(action: ActionType<typeof publicOpenDataGetChecksData>) {
  function* funcTry() {
    const { year, month, isFederalLaw } = action.payload;
    if (!Number.isNaN(Number(month))) {
      const data: ICheckesDataResponse = yield getCheckesData({ year, monthId: Number(month), isFederalLaw });
      if (data) {
        yield put(publicOpenDataSetChecksData(data));
      }
    } else {
      const data: ICheckesDataResponse = yield getCheckesPlansData({ year: String(year), isFederalLaw });
      if (data) {
        yield put(publicOpenDataSetChecksData(data));
      }
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

export function* watchPublicOpenDataSaga() {
  yield takeEvery(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_GET_DATA, publicOpenDataGetDataSaga);
  yield takeEvery(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_GET_CHECKS_DATA, publicOpenDataGetChecksDataSaga);
}
